import * as React from "react";
export function SvgDataCatalogLineageVirtualConnectionTableActive(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg width={24} height={24} {...props}>
      <path
        d="M11.5 21a1.5 1.5 0 0 1-1.374-.898l-.04-.101L6 20v-1l4.086-.001-.01.028c.146-.439.489-.788.924-.942V17H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-7v1.086c.436.154.778.502.924.941l-.01-.028L18 19v1h-5.086l.008-.022A1.5 1.5 0 0 1 11.5 21zm0-2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zM5 16h4v-2H5v2zm9 0v-2h-4v2h4zm5 0v-2h-4v2h4zm0-3v-2h-4v2h4zM5 13h4v-2H5v2zm9-2h-4v2h4v-2zM5 8v2h4V8H5zm14-3H5v2h14V5zm-4 5h4V8h-4v2zm-5-2v2h4V8h-4z"
        fill="#333"
        fillRule="evenodd"
      />
    </svg>
  );
}
